import store from '@/store'
import axios from 'axios'
import jwt from 'jsonwebtoken' 
import moment from 'moment'
import System from '../system'

export default{
    get token(){
        return store.state.auth.user?.Token || null
    },
    get isAuthenticated(){
        if(this.tokenExpireTime && moment().isBefore(moment(this.tokenExpireTime))){
            if(this.refreshTokenExpireTime && moment().isBefore(this.refreshTokenExpireTime)){
                return store.state.auth.isAuthenticated
            }else return false
        }else return false
    },
    set isAuthenticated(bool){
        store.commit('auth/SetUserAuthenticate', bool)
    },
    get refreshToken(){
        return store.state.auth.user?.RefreshToken || null
    },
    get tokenExpireTime(){
        let token = store.state.auth.user?.Token
        if(token){
            const time = jwt.decode(token)?.exp
            return Number(String(time).padEnd(13,"0")) || null
        }return null
    },
    get refreshTokenExpireTime(){
        return store.state.auth.user?.RefreshTokenExpireTime || null
    },
    get user(){
        return store.state.auth.user
    },
    set user(user){
        System.GStatus = user?.GStatus == "1" ? true : false
        store.commit('auth/SetUser', user)
        var token = user?.Token || null
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
    },
    get roleGroup(){
        let token = store.state.auth.user?.Token
        if(token){
            return jwt.decode(token)?.RoleGroup || null
        }return null
    },
    get companyId(){
        let token = store.state.auth.user?.Token
        if(token){
            return jwt.decode(token)?.CompanyId || null
        }return null
    },
    get companyName(){
        let token = store.state.auth.user?.Token
        if(token){
            return jwt.decode(token)?.CompanyName || null
        }return null
    },
    get roles(){
        return store.state.auth.user?.Roles || []
    },
    set roles(roles){
        store.commit('auth/SetRoles', roles)
    },
    get isAdmin(){
        return store.state.auth.user?.IsAdmin || false
    },
    set isAdmin(bool){
        store.commit('auth/SetIsAdmin', bool)
    },
    hasRole(array){
        if(this.isAdmin === false){
            if(this.roles){
                return this.roles.some(role => array.includes(role))
            }else return false
        }else return true
    },

    setCustomerData(data) {
        const token = data.Token || data.CustomerToken || null
        const code = data.CustomerCode || data.CariCode || null
        const tokenExpire = data.TokenExpireDate || data.TokenExpireTime || null
        const refreshExpire = data.RefreshTokenExpireTime || data.RefreshTokenExpireDate || null

        if (!token || !code) return false

        let expireIso = null
        if (tokenExpire) {
        try {
            expireIso = new Date(tokenExpire).toISOString()
        } catch {
            expireIso = null
        }
        }
        if (!expireIso) {
        const expSec = jwt.decode(token)?.exp
        if (expSec) expireIso = new Date(expSec * 1000).toISOString()
        }

        localStorage.setItem('customerToken', token)
        localStorage.setItem('customerCode', code)
        if (expireIso) localStorage.setItem('customerTokenExpireDate', expireIso)
            if (refreshExpire) {
                try {
                    localStorage.setItem('customerRefreshTokenExpireDate', new Date(refreshExpire).toISOString())
                } catch {
            }
        }
        axios.defaults.headers.common.Authorization = 'Bearer ' + token
        return true
    },

    clearCustomerData() {
        localStorage.removeItem('customerToken')
        localStorage.removeItem('customerTokenExpireDate')
        localStorage.removeItem('customerRefreshTokenExpireDate')
        localStorage.removeItem('customerCode')
        this.updateAuthHeader()
    },

    getCustomerClaims() {
        const t = this.getCustomerToken()
        if (!t) return null
        try {
        return jwt.decode(t) || null
        } catch {
        return null
        }
    },

    getCustomerToken() {
        return localStorage.getItem('customerToken')
    },

    get customerToken() { return this.getCustomerToken() },

    getCustomerCode() {
        const fromLs = localStorage.getItem('customerCode')
        if (fromLs) return fromLs
        const d = this.getCustomerClaims()
        const code =
        d?.CustomerCode ||
        d?.CariCode ||
        d?.cari_kod ||
        d?.CARI_KOD ||
        null
        if (code) localStorage.setItem('customerCode', code)
        return code
    },
    get customerCode() {
        return this.getCustomerCode()
    },

    get customerCode() { return this.getCustomerCode() },
    isCustomer() {
        const d = this.getCustomerClaims()
        if (!d) return false
        if (d.UserType === 'Customer') return true
        if (typeof d.Role === 'string' && d.Role.toLowerCase() === 'cari') return true
        const roles =
        d.role || d.roles || d.Roles || d['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || []
        if (Array.isArray(roles)) return roles.map(r => String(r).toLowerCase()).includes('customer')
        if (typeof roles === 'string') return roles.toLowerCase() === 'customer'
        return false
    },

    updateAuthHeader() {
        const customerToken = this.getCustomerToken()
        const userToken = store.state.auth.user?.Token || null
        if (customerToken) {
        axios.defaults.headers.common.Authorization = 'Bearer ' + customerToken
        } else if (userToken) {
        axios.defaults.headers.common.Authorization = 'Bearer ' + userToken
        } else {
        delete axios.defaults.headers.common.Authorization
        }
    },

    isCustomerAuthenticated() {
        const token = this.getCustomerToken()
        if (!token) return false
        const expireIso = localStorage.getItem('customerTokenExpireDate')
        if (expireIso) return moment().isBefore(moment(expireIso))
        const expSec = jwt.decode(token)?.exp
        return expSec ? Date.now() < expSec * 1000 : false
    },
    get customerAuthenticated() {
        return this.isCustomerAuthenticated()
    },

    refreshData(t,rt,rtet){
        store.commit('auth/RefreshData',{t:t,rt:rt,rtet:rtet})
    },
    
    get isResponsible(){
        return store.state.auth.user?.IsResponsibleUser || false
    }
}